import { Button, PageHeader } from '@/components';
import { useAuth } from '@/features/auth/AuthProvider';
import { ReleaseFilters, filtersFromParams } from '@/features/releases/ReleaseFilters';
import { ReleasesTable } from '@/features/releases/ReleasesTable';
import { A, useSearchParams } from '@solidjs/router';
import { hasAnyReleaseCap } from '@uchat-team-management/shared';
import { Show, createMemo } from 'solid-js';

export default function ReleaseVersionsIndex() {
  const { session } = useAuth();
  const [params] = useSearchParams();

  const canCreate = () => {
    const perms = session()?.permissions;
    return perms ? hasAnyReleaseCap(perms, 'create') : false;
  };
  // Memo so the paged table's filter-change reset only fires on real filter
  // changes, not on every params access (e.g. the page param moving).
  const filters = createMemo(() => filtersFromParams(params as Record<string, string | undefined>));

  const newDraftHref = () => {
    const query = new URLSearchParams();
    if (params.product) query.set('product', String(params.product));
    if (params.environment) query.set('environment', String(params.environment));
    // Prefill only version-shaped searches — description text isn't a version.
    if (params.q && /^[\d.]+$/.test(String(params.q))) query.set('version', String(params.q));
    return `/release/versions/new?${query}`;
  };

  return (
    <section>
      <PageHeader
        title="Versions"
        actions={
          <Show when={canCreate()}>
            <A href={newDraftHref()}>
              <Button>New draft</Button>
            </A>
          </Show>
        }
      />
      <div class="mx-auto max-w-6xl p-6">
        <ReleaseFilters />
        <ReleasesTable filters={filters} groupBy={String(params.groupBy ?? '')} />
      </div>
    </section>
  );
}
